import { Grommet, Spinner } from "grommet";
import { deepMerge } from "grommet/utils";
import { hpe } from 'grommet-theme-hpe';

import { Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { RoulettePage } from "./pages/RoulettePage";
import { AuthCallback } from "./components/auth/AuthCallback";
import { AuthComplete } from "./components/auth/AuthComplete";
import { RouletteWidgetPage } from "./pages/RouletteWidgetPage";
import { PageLayout } from "./pages/PageLayout";
import { AuctionPage } from "./pages/AuctionPage";
import { MemesDonatePage } from "./pages/MemesDonatePage";
import { MemesPage } from "./pages/MemesPage";
import { OverlaysPage } from "./pages/OverlaysPage";
import { EventsPage } from "./pages/EventsPage";
import { DashboardPage } from "./pages/DashboardPage";
import { PaymentsHistoryPage } from "./pages/PaymentsHistoryPage";
import { AuthenticatedRoute } from "./components/auth/AuthenticatedRoute";
import { MemeCreatePage } from "./pages/MemeCreatePage";
import { MemeCreateWizardTypeStep } from "./components/memes/meme-create-wizard/MemeCreateWizardTypeStep";
import { MemeCreateWizardUploadStep } from "./components/memes/meme-create-wizard/MemeCreateWizardUploadStep";
import { MemeCreateWizardInfoStep } from "./components/memes/meme-create-wizard/MemeCreateWizardInfoStep";
import { MemeCreatedSuccessfully } from "./components/memes/meme-create-wizard/MemeCreatedSuccessfully";
import RoulettePageV2 from "./pages/RoulettePageV2";
import { SettingsPageV2 } from "./pages/SettingsPageV2";
import { OverlaySettingsPage } from "./pages/OverlaySettingsPage";
import { DonateVariantsPage } from "./pages/DonateVariantsPage";
import { PaymentMethodsPage } from "./pages/PaymentMethodsPage";
import { DonatePage } from "./pages/DonatePage";
import { HomePage } from "./pages/HomePage";
import { LogoutSync } from "./components/auth/LogoutSync";

const noBorderStyle = `
  > div {
    border: none;
    > div {
      padding: 0;
    }
  }
`;

const noHoverStyle = `
  > div {
    margin: 0;
    box-shadow: unset;
  }
  > div > label:hover {
    background: unset;
  }
  > div > label {
    padding: 6px 0px;
  }
`

function App() {

  const mainColor = "#a6025c";
  const hoverColor = "#87004a";

  const theme = deepMerge(hpe, {
    global: {
      font: {
        face: {
          'font-family': 'Roboto Mono',
          family: 'monospace'
        }
      },
      colors: {
        focus: mainColor,
        brand: mainColor,
        "green!": mainColor,
        "green": {
          "dark": hoverColor,
          "light": hoverColor
        }
      }
    },
    table: {
      header: {
        pad: { left: '12px', right: '12px', top: '6px', bottom: '6px' },
        verticalAlign: 'bottom',
        fill: 'vertical',
        border: 'bottom',
        align: 'start'
      }
    },
    formField: {
      extend: ({ noBorder, noHover, noFocus }) => `
        ${noBorder ? noBorderStyle : ''}
        ${noHover ? noHoverStyle : ''}
        ${noFocus ? '> div { box-shadow: none; }' : ''}
      `
    },
  });

  return (
    <Grommet background={'transperent'} theme={theme} themeMode="dark" style={{ overflowX: 'hidden' }}>
      <Suspense fallback={<Spinner/>}>
        <BrowserRouter future={{ v7_startTransition: true }}>
          <LogoutSync />
          <Routes>
            <Route path="/auth/complete" element={<AuthComplete/>}/>
            <Route path="/" element={<PageLayout />}>
              <Route index element={<HomePage />}/>
              <Route path="auction" element={<AuctionPage/>}/>
              <Route path="auction/:tab" element={<AuctionPage/>}/>
              <Route path="roulette" element={<RoulettePage/>}/>
              <Route path="callback" element={<AuthCallback/>}/>
              {/* <Route path="settings" element={<AuthenticatedRoute><SettingsPage/></AuthenticatedRoute>}/> */}
              <Route path="settings" element={<AuthenticatedRoute><SettingsPageV2/></AuthenticatedRoute>}>
                <Route index path="overlay-settings" element={<OverlaySettingsPage />} />
                <Route path="donate-options" element={<DonateVariantsPage />} />
                <Route path="payment-methods" element={<PaymentMethodsPage />} />
              </Route>
              <Route path="memes" element={<MemesPage/>}/>
              <Route path="memes/create" element={<AuthenticatedRoute><MemeCreatePage/></AuthenticatedRoute>}>
                <Route index element={<MemeCreateWizardTypeStep/>} />
                <Route path="upload" element={<MemeCreateWizardUploadStep/>} />
                <Route path="info" element={<MemeCreateWizardInfoStep/>} />
                <Route path="success" element={<MemeCreatedSuccessfully/>} />
              </Route>
              <Route path="memes/:username" element={<MemesDonatePage />} />
              <Route path="d/:username" element={<DonatePage />} />
              <Route path='/dashboard' element={<AuthenticatedRoute><DashboardPage/></AuthenticatedRoute>}>
                <Route index element={<EventsPage />} />
                <Route index path='events' element={<EventsPage />} />
                <Route path='roulette' element={<RoulettePageV2 />} />
                <Route path='payments-history' element={<PaymentsHistoryPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" />}/>
            </Route>
            <Route path="/widgets">
              <Route path="roulette/:rouletteId" element={<RouletteWidgetPage/>} />
            </Route>
            <Route path="/overlays">
              <Route path=":token" element={<OverlaysPage />}/>
            </Route>
          </Routes>
        </BrowserRouter>
      </Suspense>
    </Grommet>
  );
}

export default App;
